module.exports = __webpack_public_path__ + "elements/footer/hkt-logo.png?ver=1edfc220";